<template>
  <div class="flex flex-col gap-2 w-full">
    <div
      class="bg-white rounded-xl border border-untitled-gray-100 shadow-sm p-4 flex flex-col gap-2"
      v-for="n in 4"
      :key="n"
    >
      <div class="flex items-start justify-between gap-2">
        <div class="h-4 w-1/2 rounded-md bg-untitled-gray-200 animate-pulse" />
        <div
          class="h-5 w-5 rounded-full bg-untitled-gray-200 animate-pulse shrink-0"
        />
      </div>

      <div class="flex flex-col gap-1.5">
        <div class="h-3.5 w-full rounded-md bg-untitled-gray-200 animate-pulse" />
        <div class="h-3.5 w-2/3 rounded-md bg-untitled-gray-200 animate-pulse" />
      </div>

      <div class="h-3.5 w-1/3 rounded-md bg-untitled-gray-200 animate-pulse" />

      <div class="h-3.5 w-24 rounded-md bg-untitled-gray-200 animate-pulse" />
    </div>
  </div>
</template>

<script setup></script>

<style lang="scss" scoped></style>
